import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { CAMPAIGN_VIDEO_REPORT_ID } from './campaignVideoReportId';

const emptyColumns = [
    FIELDS.IS_ACTIVE,
    FIELDS.ID,
    FIELDS.NAME,
    FIELDS.VIDEO_BUDGET,
    FIELDS.STATUS,
    FIELDS.VIDEO_MODEL_TYPE,
    FIELDS.START_DATE,
    FIELDS.END_DATE,
    FIELDS.ACTIONS_COLUMN,
].map(createFooterMapper(CAMPAIGN_VIDEO_REPORT_ID));

const campaignReportFooterColumnDefinition = [...emptyColumns];

export default campaignReportFooterColumnDefinition;
